import React, { useState } from 'react';
import ContractViewer from '../ContractViewer';

const HelpButton = ({ helpData }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  if (!helpData) return null;
  return (
    <>
      <button
        onClick={() => setPdfUrl(helpData[0].urlFilter)}
        style={{
          background: 'rgba(34, 211, 238, 0.1)',
          border: '1px solid rgba(34, 211, 238, 0.15)',
          borderRadius: '8px',
          color: '#22d3ee',
          padding: '6px 8px',
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      </button>
      {pdfUrl && (
        <ContractViewer pdfUrl={pdfUrl} onClose={() => setPdfUrl(null)} />
      )}
    </>
  );
};

export default HelpButton;